import {MainPageConfig} from "@/interfaces/main-page.interface";

export namespace PathOverviewPageConfig {

  export interface IPathOverviewPageConfig {
    entity_id: string;
    title: string;
    description: string;
    content: MainPageConfig.ITheme[];
  }

  export enum PathViewMode {
    Default = 'default',
    Small = 'small',
    Wide = 'wide',
  }
}
